import { Typography } from "@mui/material";

export default function CurrencyCell({
  value,
  align = "right",
}) {
  return (
    <Typography
      textAlign={align}
      fontSize={14}
    >
      {Number(value || 0).toLocaleString(
        "en-IN",
        {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }
      )}
    </Typography>
  );
}